import { requestApi } from 'api/api'
import { BASE_API_URL } from 'constants/General'
import { CountryData } from 'types/countries'

export const getCountryStates = (countryCode: string): Promise<CountryData[]> => {
  return requestApi({
    baseUrl: BASE_API_URL,
    url: `/platform/v1/accounts/country/${countryCode}/states`,
    method: 'GET',
    authenticated: false,
  })
}
